import {
  LiveMonitorTopBarActions,
  LiveMonitorView,
  type LiveMonitorDemoState,
} from '@elva/ui';
import { useState } from 'react';
import { usePageTopBar } from '@/app/layouts/pageTopBar';

/**
 * AI Receptionist agent page (spec §2.3): the standalone product's "Live feed"
 * lives here — every call in and out, right now. Backed by the shared
 * LiveMonitorView.
 */
export function AiReceptionistPage() {
  const [demoState, setDemoState] = useState<LiveMonitorDemoState>('active');

  usePageTopBar({
    actions: (
      <LiveMonitorTopBarActions demoState={demoState} onDemoStateChange={setDemoState} />
    ),
  });

  return <LiveMonitorView demoState={demoState} />;
}
